import { NotificationResponse } from '@/types/notification';
import { apiSlice } from './apiSlice';

export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<NotificationResponse, { type?: string } | void>({
      query: (params = {}) => {
        return {
          url: `/notifications`,
          method: 'GET',
          params: { t: Date.now() },
        };
      },
    }),
  }),
});

export const { useGetNotificationsQuery } = notificationApi;
